// MVK-3905 — modal adapter đang dùng cho các Stimulus controller dùng chung (region-picker, cinema-list).
// `boot(modal)` gán adapter một lần; controller chỉ nói chuyện với ba hàm dưới đây nên không biết Bootstrap hay Flowbite.
//
// Adapter = { show(el), hide(el), onShow(el, callback) -> unsubscribe, isShown(el) }, nhận PHẦN TỬ. Controller giữ id modal
// trong Stimulus value ⇒ các hàm ở đây nhận id (hoặc phần tử) rồi tra phần tử; thiếu phần tử thì im lặng như không có modal.
let adapter = null;

export function setModal(modal) {
    adapter = modal;
}

function current() {
    if (!adapter) throw new Error('Modal adapter chưa được gán: gọi boot(modal) trước khi controller connect.');

    return adapter;
}

function resolve(idOrElement) {
    return typeof idOrElement === 'string' ? document.getElementById(idOrElement) : idOrElement;
}

// Chạy `handler` mỗi khi modal BẮT ĐẦU mở. Trả về hàm gỡ listener.
export function onModalShow(idOrElement, handler) {
    const element = resolve(idOrElement);

    return element ? current().onShow(element, handler) : () => {};
}

// Modal đang mở HOẶC đang mở dở (Bootstrap: backdrop còn fade).
export function isModalShown(idOrElement) {
    const element = resolve(idOrElement);

    return element ? current().isShown(element) : false;
}

export function closeModal(idOrElement) {
    const element = resolve(idOrElement);
    if (element) current().hide(element);
}
